// extracted by mini-css-extract-plugin
module.exports = {"buttonPrimary":"FMButtons_buttonPrimary__SjUwy"};